import { withParseAvailability } from '@eti/products';
import { hasAvailability } from '../../payment/entry-page/utils/ancillaryProducts';

export const getProductWithPartialAvailability = (bounds, getTranslation, products, travelers) =>
  products.map((product) => {
    const { productSpecificTexts, ...rest } = product;

    const parseAvailability = withParseAvailability(
      Number(product.id),
      getTranslation,
      `${product.name.toLowerCase()}GeneralPurpose`,
    );

    return {
      availability: hasAvailability(productSpecificTexts)
        ? parseAvailability(
            productSpecificTexts?.productSegmentAvailabilityTexts,
            bounds,
            travelers.length,
          )
        : null,
      ...rest,
    };
  });

export const generateBundleInitialValues = (bundle, bounds, getTranslation, travelers) => {
  const { id, selectedOption, options } = bundle;

  const selection = options.find((option) => option.id === selectedOption);

  const products =
    selection?.content?.filter((product) => product.name !== null && product.included) ?? [];

  // TODO: Revisit for better implementation
  return selection
    ? {
        id,
        title: selection.name,
        price: selection?.price?.price?.value,
        value: selection.id,
        products: getProductWithPartialAvailability(bounds, getTranslation, products, travelers),
        options,
        selectedOption,
      }
    : false;
};

export const generateInitialValuesAncillaryBundles = (
  bundles = [],
  bounds,
  getTranslation,
  travelers,
) => ({
  bundles: bundles.reduce((acc, bundle) => {
    const selectedOption = bundle?.selectedOption;
    if (selectedOption !== null) {
      return [...acc, generateBundleInitialValues(bundle, bounds, getTranslation, travelers)];
    }
    return [...acc];
  }, []),
});
